require('./foo');
require('./beep');
